// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"19aeda2d","133":"0305bf02","963":"8460cc50"}[chunkId] + ".chunk.js";
};